export default __webpack_public_path__ + "static/image_contact_s-e68a5aab42eba227363e206d83484f7f.jpg";